/**
 * @Author: Zero
 * @Date: 2024-09-27 09:20:43
 * @Explain: 表单 - 埋点事件
 */

export default {
  /** 表单 - 列表 - 列表加载异常上报 */
  501: 'loadSignFormManageListError',
  /** 表单 - 列表 - 删除表单失败上报 */
  502: 'deleteSignFormManageItemError',
  /** 表单- 新增表单 - 新增表单失败上报 */
  503: 'addSignFormManageItemError',
  /** 表单- 新增表单 - 编辑处于新增流程表单失败上报 */
  504: 'editSignFormManageItemError',
  /** 表单- 编辑表单 - 编辑获取单个表单详细信息失败上报 */
  505: 'getSignFormDetailsManageItemError',
  /** 表单- 编辑表单 - 编辑表单失败上报 */
  506: 'editSignFormManageItemError',
  /** 表单- 复制表单 - 复制获取单个表单详细信息失败上报 */
  507: 'getSignFormDetailsManageItemError',
  /** 表单- 复制表单 - 复制表单失败上报 */
  508: 'addSignFormManageItemError',
  /** 表单- 复制表单 - 编辑处于复制流程表单失败上报 */
  509: 'editSignFormManageItemError',
  /** 表单- 详情 - 详情获取单个表单详细信息失败上报 */
  510: 'getSignFormDetailsManageItemError',
};
